import React from 'react';
import PropTypes from 'prop-types';
import DropdownMenu from './DropdownMenu';

export default class LogInOrSignUpMenu extends React.Component {
    getDropdownItemData() {
        const options = [];
        options.push({
            label: this.logInOrSignUpHtml(),
            key: 'like',
        });
        return options;
    }

    logInOrSignUpHtml() {
        return (
            <span
                dangerouslySetInnerHTML={
                    { __html: this.props.design.login_or_signup }
                }
            />
        );
    }

    render() {
        return (
            <DropdownMenu
                itemData={this.getDropdownItemData()}
            >
                <button
                    className="like-button icon icon--like-1"
                />
            </DropdownMenu>
        );
    }
}

LogInOrSignUpMenu.contextTypes = {
    intl: PropTypes.object.isRequired,
};

LogInOrSignUpMenu.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/LogInOrSignUpMenu.jsx